module.exports = __webpack_public_path__ + "img/gratitude-journal_B095MB7VQ2.68780b6d.jpg";